import React, { useState } from 'react';
import { Form, Input, InputNumber, Select, Button, message } from 'antd';
import { equipamentosService } from '../../services/api';

const { Option } = Select;

const StepCarregador = ({ siteId, currentStep, totalSteps, onPrev, onNext }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    const handleSave = async () => {
        if (!siteId) {
            message.error('Selecione ou salve um site no passo anterior.');
            return;
        }
        try {
            setLoading(true);
            await form.validateFields();
            const values = form.getFieldsValue();
            const payload = {
                name: values.nome || `Carregador EV ${values.potenciaKw || ''}kW`,
                type: 'ESTACAO_RECARGA',
                status: 'CONECTADO',
                siteId,
                serialNumber: values.numeroSerie || null,
                manufacturer: values.fabricante || null,
                model: values.modelo || null,
                capacity: values.potenciaKw ? Number(values.potenciaKw) : null,
                potenciaKw: values.potenciaKw ? Number(values.potenciaKw) : null,
            };
            const res = await equipamentosService.create(payload);
            const equipment = res?.data ?? res;
            if (equipment?.id) {
                message.success('Carregador (Estação de Recarga) cadastrado com sucesso!');
                setSaved(true);
            }
        } catch (error) {
            message.error(error.response?.data?.message || 'Erro ao salvar Carregador.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 24, backgroundColor: 'white' }}>
            <h2 style={{ color: '#2957A4', marginBottom: 16 }}>Carregador (Estação de Recarga)</h2>
            <Form form={form} layout="vertical">
                <Form.Item name="nome" label="Nome" rules={[{ required: true }]}>
                    <Input placeholder="Ex: Carregador EV Principal" />
                </Form.Item>
                <Form.Item name="potenciaKw" label="Potência (kW)" rules={[{ required: true }]}>
                    <Select placeholder="Selecione a potência">
                        <Option value={7}>7 kW</Option>
                        <Option value={11}>11 kW</Option>
                        <Option value={22}>22 kW</Option>
                        <Option value={50}>50 kW</Option>
                        <Option value={60}>60 kW</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="fabricante" label="Fabricante">
                    <Input placeholder="Ex: Wallbox, ABB" />
                </Form.Item>
                <Form.Item name="modelo" label="Modelo">
                    <Input placeholder="Modelo do carregador" />
                </Form.Item>
                <Form.Item name="numeroSerie" label="Número de Série">
                    <Input placeholder="Número de série" />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24, gap: 8 }}>
                    {currentStep > 0 && <Button onClick={onPrev}>Voltar</Button>}
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                        {currentStep < totalSteps - 1 && (
                            <Button onClick={onNext}>Próximo</Button>
                        )}
                        <Button type="primary" onClick={handleSave} loading={loading} style={{ backgroundColor: '#2957A4', borderColor: '#2957A4' }}>
                            Salvar
                        </Button>
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default StepCarregador;
